export const environment = {
  production: true,
  contactURL: 'https://us-central1-my-website-b71e9.cloudfunctions.net/contact',
  analyticsEnabled: true,
  cookieDomain: 'nhdsgn.com',
};
